import type { FunctionComponent, PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

import { getRouteDefinitionForPathname } from "../routes/catalog";

type Props = PropsWithChildren<{
  isAuthenticated: boolean;
}>;

const maxWidthByLayout = {
  public: "none",
  standard: 1040,
  wide: 1800,
  "edge-to-edge": "none",
} as const;

export const AppRouteFrame: FunctionComponent<Props> = ({ children, isAuthenticated }) => {
  const { pathname } = useLocation();
  const route = getRouteDefinitionForPathname(pathname);
  const maxWidth = maxWidthByLayout[route.layout];

  return (
    <Box
      component="main"
      className="app-shell-content"
      data-layout={route.layout}
      data-route-id={route.id}
      sx={{
        minWidth: 0,
        minHeight: "100vh",
        "--app-nav-offset": isAuthenticated ? "56px" : "64px",
        ml: 0,
        pt: isAuthenticated ? "56px" : "64px",
        transition: "margin-left 180ms ease",
        "@media (min-width: 768px)": {
          ml: isAuthenticated ? "72px" : 0,
          pt: isAuthenticated ? 0 : "64px",
          "--app-nav-offset": isAuthenticated ? "0px" : "64px",
        },
        "@media (min-width: 1280px)": {
          ml: isAuthenticated ? "212px" : 0,
        },
        "@media print": { ml: "0 !important", pt: "0 !important" },
      }}
    >
      <Box
        className="app-route-layout"
        sx={{
          width: "100%",
          maxWidth,
          minHeight: "inherit",
          mx: maxWidth === "none" ? 0 : "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
